let bottleSection = document.querySelector(".section_bottle");

if (bottleSection) {
  const bottleEase = "power1.out";

  const bottleWrap = document.querySelector(".bottle_bottle-wrap");
  const bottleCircle = document.querySelector(".bottle_circle");

  const bottleContentItems = document.querySelectorAll(".bottle_content-item");

  const cap = document.querySelector(".bottle_cap");
  const serum = document.querySelector(".bottle_serum");
  const bottle = document.querySelector(".bottle_bottle");

  let bottleTl = gsap.timeline()

  bottleTl = gsap.timeline({
    scrollTrigger: {
      trigger: bottleWrap,
      scrub: 0.5,
      markers: false,
      start: "top 40%",
      end: "bottom top",
    }
  });

  bottleTl
    .to(cap, {
      y: "-30rem",
      ease: bottleEase,
    })
    .to(
      serum,
      {
        y: "-7.5rem",
        ease: bottleEase,
      },
      "<"
    )
    .to(
      bottle,
      {
        y: "7.5rem",
        ease: bottleEase,
      },
      "<"
    )
    .to(
      bottleWrap,
      {
        scale: 0.85,
        y: "5rem",
        ease: bottleEase,
      },
      "<"
    )

  gsap.to(bottleCircle, {
    rotate: 360,
    repeat: -1,
    duration: 100,
  });

  // Use GSAP's matchMedia to control when the masterTimeline runs

  gsap.matchMedia().add("(min-width: 480px)", () => {
    // This code only runs if the screen width is 480px or greater
    const masterTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: bottleWrap,
        scrub: false,
        markers: false,
        start: "top 40%",
        end: "bottom top",
        toggleActions: "play pause resume reverse",
      },
    });

    bottleContentItems.forEach((el, index) => {
      const contentDot = el.querySelector(".bottle_dot");
      const contentHeading = el.querySelector(".bottle_content-heading");
      const contentParagraph = el.querySelector(".bottle_content-p");

      if (!contentDot || !contentHeading || !contentParagraph) {
        console.error(
          "One or more child elements are missing in .bottle_content-item:",
          el
        );
        return;
      }

      const tl = gsap.timeline();

      tl.from(contentDot, {
          x: "15rem",
          scale: 0,
          duration: 0.5,

          ease: "back.out",
        })
        .from(
          contentHeading,
          {
            y: "2rem",
            opacity: 0,
            duration: 0.75,
            filter: "blur(2px)",
            ease: "power3.out",
          },
          "-=0.35"
        )
        .from(
          contentParagraph,
          {
            y: "2rem",
            opacity: 0,
            duration: 0.75,
            filter: "blur(2px)",
            ease: "power3.out",
          },
          "-=0.65"
        );

      masterTimeline.add(tl, index * 0.2);
    });
  });
}
